export default __webpack_public_path__ + "static/media/ratingStar.fa599f6e.svg";